import { Check, Lock } from 'lucide-react';
import { Link } from 'react-router';
import { formatEuro } from '@brimo/shared';
import { PhoneFrame } from '../frame/PhoneFrame';
import styles from '../frame/Phone.module.css';
import type { PortalActivation } from '../types';
import local from './Activation.module.css';

/** Mandantenportal 09 „Ihr Portal steht bereit": the blurred volume as teaser (hidden without a volume). */
export function ReadyScreen({ result }: { result: PortalActivation }) {
  return (
    <PhoneFrame tone="navy" title="Mandantenportal">
      <div className={local.readyHead}>
        <span className={local.readyIcon} aria-hidden="true">
          <Check size={24} strokeWidth={1.5} />
        </span>
        <h1 className={local.readyTitle}>Ihr Portal steht bereit</h1>
        <p className={local.readyText}>
          Melden Sie sich an, um Ihr Finanzierungsvolumen zu sehen und Ihren Beratungstermin zu buchen.
        </p>
      </div>
      {result.volumeCents !== null ? (
        <div className={`${styles.glass} ${local.readyCard}`}>
          <div className={styles.eyebrow}>Ihr Finanzierungsvolumen</div>
          <div className={local.readyAmount} aria-hidden="true">
            {formatEuro(result.volumeCents)}
          </div>
          <div className={local.readyLock}>
            <Lock size={15} strokeWidth={1.5} aria-hidden="true" />
            <span>Sichtbar nach dem ersten Login</span>
          </div>
        </div>
      ) : null}
      <div className={`${styles.footer} ${local.navyFooter}`}>
        <Link to={result.portalHref} className={`pressable ${styles.primary} ${local.bigPrimary}`}>
          Zum Portal anmelden
        </Link>
        <div className={styles.small}>Den Link haben wir Ihnen zusätzlich per E-Mail geschickt.</div>
      </div>
    </PhoneFrame>
  );
}
